import Alert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AuthService from 'services/authService';

const NoAccessMessage = (props: any) => {

     const history = useHistory();

     useEffect(() => {
          setTimeout(() => {
               AuthService.signOutRedirect();     
          }, 10000);
     },[]);
     
     
     return (
       <section className="flex-col-center">
            <Alert severity="info" className="mt-2">
            Access to the console is currently restricted to Trimble users only. For more information regarding 
            external access availability, please contact Trimble Cloud Support.
            </Alert>
       </section>        
     );
}

export default (NoAccessMessage);